export default "<p>\n  courier-tcs works!\n</p>\n"